import { sharedData } from "./sharedData";

import uuid from "react-uuid";

export const navMainTitle = [
	{
		id: 1,
		mainTitle: "درباره‌ ما",
		mainLink: "/" + sharedData.utmParams,
		isLink: false,
		uuid: uuid(),
	},
	{
		id: 2,
		mainTitle: "کسب و کار ما",
		mainLink: "https://about.digikala.com/our-business/" + sharedData.utmParams,
		isLink: false,
		uuid: uuid(),
	},
	{
		id: 3,
		mainTitle: "اخبار‌ و منابع",
		mainLink:
			"https://about.digikala.com/news-and-resources/" + sharedData.utmParams,
		isLink: false,
		uuid: uuid(),
	},
	{
		id: 4,
		mainTitle: "راهبران",
		mainLink: "/leadership" + sharedData.utmParams,
		isLink: true,
		uuid: uuid(),
	},
	{
		id: 5,
		mainTitle: "مسئولیت ما",
		mainLink:
			"https://about.digikala.com/our-responsibility/" + sharedData.utmParams,
		isLink: false,
		uuid: uuid(),
	},
	{
		id: 8,
		mainTitle: "گزارش سال دیجی‌کالا",
		mainLink:
			"https://about.digikala.com/reports/digikala1404/" + sharedData.utmParams,
		isLink: false,
		uuid: uuid(),
	},
	{
		id: 7,
		mainTitle: "بلاگ‌ها",
		mainLink: "/blogs" + sharedData.utmParams,
		isLink: false,
		uuid: uuid(),
	},
];
export const navbarData = [
	{
		id: 1,
		subMenu: [
			{
				title: "هویت ما​",
				link: "/digikala-identity/" + sharedData.utmParams,
				uuid: uuid(),
			},
			{
				title: "تاریخچه دیجی‌کالا",
				link: "/history/" + sharedData.utmParams,
				uuid: uuid(),
			},
			{
				title: "گروه تجارت الکترونیک دیجی‌کالا",
				link: "/digikala-group" + sharedData.utmParams,
				uuid: uuid(),
			},
		],
	},
	{
		id: 2,
		subMenu: [
			{
				title: "مارکت پلیس دیجی‌کالا",
				link: "/digikala-marketplace/" + sharedData.utmParams,
				uuid: uuid(),
			},
			{
				title: "کسب و کارهای بومی و محلی",
				link:
					"https://www.digikala.com/landings/village-businesses/" +
					sharedData.utmParams,
				uuid: uuid(),
			},
			{
				title: "لجستیک و عملیات",
				link: "/logistic/" + sharedData.utmParams,
				uuid: uuid(),
			},
			{
				title: "دیجی‌کالا بیزینس",
				link:
					"https://www.digikala.com/landings/business-registration/" +
					sharedData.utmParams,
				uuid: uuid(),
			},
		],
	},
	{
		id: 3,
		subMenu: [
			{
				title: "اتاق خبر دیجی‌کالا",
				link: "/newsroom/" + sharedData.utmParams,
				uuid: uuid(),
			},
			{
				title: "پلتفرم ویدیو",
				link: "/videos/" + sharedData.utmParams,
				uuid: uuid(),
			},
			{
				title: "گزارش‌های گروه دیجی‌کالا",
				link: "https://about.digikala.com/reports/" + sharedData.utmParams,
				uuid: uuid(),
			},
			{
				title: "بسته رسانه‌ای",
				link: "/mediakit/" + sharedData.utmParams,
				uuid: uuid(),
			},
			{
				title: "اخبار فناوری دیجی‌کالا",
				link: "https://techteam.digikala.com/" + sharedData.utmParams,
				uuid: uuid(),
			},
		],
	},
	{
		id: 4,
		subMenu: [],
	},
	{
		id: 5,
		subMenu: [
			{
				title: "حمایت از کسب و کارهای کوچک",
				link: "/supportsmallbusiness/" + sharedData.utmParams,
				uuid: uuid(),
			},
			{
				title: "پایداری اجتماعی و محیط زیستی",
				link: "/social-and-environmental-sustainability" + sharedData.utmParams,
				uuid: uuid(),
			},
			{
				title: "دیجی‌کالا مهر",
				link: "/digikalamehr/" + sharedData.utmParams,
				uuid: uuid(),
			},
		],
	},
	{
		id: 6,
		subMenu: [],
	},
	{
		id: 7,
		subMenu: [
			{
				title: "بلاگ راهبران",
				link: "/blogs/leadership/" + sharedData.utmParams,
				uuid: uuid(),
			},
			{
				title: "بلاگ داستان‌پردازی با داده",
				link: "/blogs/data-storytelling/" + sharedData.utmParams,
				uuid: uuid(),
			},
			// {
			//   title: "بلاگ مسئولیت اجتماعی",
			//   link: "/blogs/social-responsibility/" + sharedData.utmParams,
			//   uuid: uuid(),
			// },
		],
	},
	{
		id: 8,
		subMenu: [
			{
				title: "گزارش سال ۱۴۰۴",
				link:
					"https://about.digikala.com/reports/digikala1404/" +
					sharedData.utmParams,
				uuid: uuid(),
			},
			{
				title: "گزارش سال ۱۴۰۳",
				link:
					"https://about.digikala.com/reports/digikala1403/" +
					sharedData.utmParams,
				uuid: uuid(),
			},
			{
				title: "گزارش سال ۱۴۰۲",
				link:
					"https://about.digikala.com/reports/digikala1402/" +
					sharedData.utmParams,
				uuid: uuid(),
			},
			{
				title: "آرشیو گزارش‌ها",
				link: "https://about.digikala.com/reports/" + sharedData.utmParams,
				uuid: uuid(),
			},
		],
	},
];

export const navMainTitleEn = [
	{
		id: 1,
		mainTitle: "About Us",
		mainLink: "https://about.digikala.com/en/" + sharedData.utmParams,
		isLink: false,
		uuid: uuid(),
	},
	{
		id: 2,
		mainTitle: "Our Business",
		mainLink: "https://about.digikala.com/our-business/" + sharedData.utmParams,
		isLink: false,
		uuid: uuid(),
	},
	{
		id: 3,
		mainTitle: "News and Resources",
		mainLink:
			"https://about.digikala.com/news-and-resources/" + sharedData.utmParams,
		isLink: false,
		uuid: uuid(),
	},
	{
		id: 4,
		mainTitle: "Leadership",
		mainLink: "/en/leadership" + sharedData.utmParams,
		isLink: true,
		uuid: uuid(),
	},
	{
		id: 5,
		mainTitle: "Our Responsibility",
		mainLink:
			"https://about.digikala.com/our-responsibility/" + sharedData.utmParams,
		isLink: false,
		uuid: uuid(),
	},
];

export const navbarDataEn = [
	{
		id: 1,
		subMenu: [
			{
				title: "Digikala Identity",
				link: "/en/digikala-identity/" + sharedData.utmParams,
				uuid: uuid(),
			},
			{
				title: "The History of Digikala",
				link: "/en/history/" + sharedData.utmParams,
				uuid: uuid(),
			},
			{
				title: "Digikala E-Commerce Group",
				link: "/en/digikala-group" + sharedData.utmParams,
				uuid: uuid(),
			},
		],
	},
	{
		id: 2,
		subMenu: [
			{
				title: "Digikala Marketplace",
				link: "/en/digikala-marketplace/" + sharedData.utmParams,
				uuid: uuid(),
			},
			{
				title: "Native and Local Businesses",
				link:
					"https://www.digikala.com/landings/village-businesses/" +
					sharedData.utmParams,
				uuid: uuid(),
			},
			{
				title: "Logistics and Operations",
				link: "/en/logistic/" + sharedData.utmParams,
				uuid: uuid(),
			},
			{
				title: "Digikala Business",
				link:
					"https://www.digikala.com/landings/business-registration/" +
					sharedData.utmParams,
				uuid: uuid(),
			},
		],
	},
	{
		id: 3,
		subMenu: [
			{
				title: "Newsroom",
				link: "/en/newsroom/" + sharedData.utmParams,
				uuid: uuid(),
			},
			{
				title: "Video Platform",
				link: "/en/videos/" + sharedData.utmParams,
				uuid: uuid(),
			},
			{
				title: "Digikala Reports",
				link: "https://about.digikala.com/en/reports/" + sharedData.utmParams,
				uuid: uuid(),
			},
			{
				title: "Media Kit",
				link: "/mediakit/" + sharedData.utmParams,
				uuid: uuid(),
			},
			{
				title: "Digikala Technology News",
				link: "https://techteam.digikala.com/" + sharedData.utmParams,
				uuid: uuid(),
			},
		],
	},
	{
		id: 4,
		subMenu: [],
	},
	{
		id: 5,
		subMenu: [
			{
				title: "Supporting Small Businesses",
				link: "/en/supportsmallbusiness/" + sharedData.utmParams,
				uuid: uuid(),
			},
			{
				title: "Social and Eenvironmental Sustainability",
				link:
					"/en/social-and-environmental-sustainability" + sharedData.utmParams,
				uuid: uuid(),
			},
			{
				title: "Digikala Mehr",
				link: "/en/digikalamehr/" + sharedData.utmParams,
				uuid: uuid(),
			},
		],
	},
	{
		id: 6,
		subMenu: [],
	},
];
